<template>
  <!-- Page Content -->
  <div class="content content-page">
    <div class="container">
      <div class="row">
        <projectsidebar></projectsidebar>
        <div class="col-xl-9 col-lg-8">
          <div class="page-title">
            <h3>Completed Projects</h3>
          </div>
          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              Website Designer Required For Directory Theme
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Hourly</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>4 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$500</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <span>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  4.5
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/user-04.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Hannah Finn</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              Landing Page Redesign / Sales Page Redesign
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Fixed</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>5 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$280</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <a
                                  href="#write-review"
                                  data-bs-toggle="modal"
                                  class="btn-write-review mb-0"
                                  >Write Review</a
                                >
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/table-avatar-02.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Bolethe Fleischer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              WooCommerce Product Page Back Up Restoration
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Hourly</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>3 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$700</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <span>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  4.5
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/table-avatar-03.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Gerth Enoksen</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              Laravel Backend Developer to finish ongoing project
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Fixed</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>8 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$300</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <span>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  4.5
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/table-avatar-04.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Larry Higdon</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              3D Renders and Amazon Product Store images/Video
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Fixed</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>8 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$300</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <span>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  4.5
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/user-02.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Nicole Estrada</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <!-- project list -->
          <div class="my-projects-list ongoing-projects">
            <div class="row">
              <div class="col-xl-9 flex-wrap">
                <div class="freelancer-proposals proposal-ongoing mb-0">
                  <div class="project-proposals align-items-center freelancer">
                    <div class="proposal-info">
                      <div class="proposals-details">
                        <span class="tech-name-badge">Dreamguystech</span>
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="employee-project-card">
                            <h3 class="proposals-title">
                              Website Designer Required For Directory Theme
                            </h3>
                            <ul>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Project type</h4>
                                  <h3>Hourly</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Location</h4>
                                  <h3 class="flag-icon">
                                    <img
                                      src="@/assets/img/icon/flag-icon.svg"
                                      height="13"
                                      alt="Lang"
                                    />
                                    UK
                                  </h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Expiry</h4>
                                  <h3>4 Days Left</h3>
                                </div>
                              </li>
                              <li>
                                <div class="proposal-job-type">
                                  <h4 class="title-info">Price</h4>
                                  <h3>$500</h3>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <ul class="employee-project">
                            <li>
                              <div class="project-action text-center">
                                <router-link
                                  to="/employers/completed-projects-view-details"
                                  class="projects-btn"
                                  >View Details</router-link
                                >
                                <a
                                  href="javascript:void(0);"
                                  class="projects-btn completed-btn"
                                  ><i class="fa fa-award me-2"></i>Completed</a
                                >
                                <span>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  <i class="fa-solid fa-star"></i>
                                  4.5
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 d-flex flex-wrap">
                <div class="projects-card flex-fill">
                  <div class="card-body p-2">
                    <div class="prj-proposal-count text-center hired">
                      <h3>Hired</h3>
                      <img
                        src="@/assets/img/user/user-04.jpg"
                        alt="Img"
                        class="img-fluid"
                      />
                      <p class="mb-0">Hannah Finn</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /project list -->

          <div class="row">
            <div class="col-md-12">
              <ul class="paginations list-pagination">
                <li class="page-item">
                  <a href="javascript:void(0);"><i class="feather-chevron-left"></i></a>
                </li>
                <li class="page-item">
                  <a href="javascript:void(0);" class="active">1</a>
                </li>
                <li class="page-item"><a href="javascript:void(0);">2</a></li>
                <li class="page-item"><a href="javascript:void(0);">3</a></li>
                <li class="page-item"><a href="javascript:void(0);">...</a></li>
                <li class="page-item"><a href="javascript:void(0);">10</a></li>
                <li class="page-item">
                  <a href="javascript:void(0);"><i class="feather-chevron-right"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- /Page Content -->

  <completedprojects></completedprojects>
</template>
